module.exports = __webpack_public_path__ + "static/dealing-with-china-4e8bee10e1866b5cce6acb6399208237.jpg";